import { Divider } from 'antd';
import { get } from 'lodash-es';

import { ConsumerSettings } from '@page/consumer-view/consumer-settings/consumer-settings';

import { Tabs } from '@atom/tabs/tabs';
import { Text, Title } from '@atom/typography/typography';
import { ConsumerId } from '@component/consumer-id/consumer-id';
import { useMemberRole } from '@hook/memeber/use-member-role.hook';

import { ConsumerCredentials } from './consumer-credentials/consumer-credentials';
import { ConsumerGuide } from './consumer-guide/consumer-guide';
import { ConsumerIntegrations } from './consumer-integrations/consumer-integrations';
import { ConsumerLogs } from './consumer-logs/consumer-logs';
import { ConsumerStats } from './consumer-stats/consumer-stats';
import { useConsumerView } from './consumer-view.hook';
import { ConsumerStatsWrapper, Wrapper } from './consumer-view.page-style';
import { ConsumerViewTabEnum } from './consumer-view.tab-enum';

export const ConsumerViewPage = () => {
  const { consumer, consumerTab } = useConsumerView();
  const { isOwner, isAdmin } = useMemberRole();

  return (
    <>
      <Wrapper>
        <Title level={2} weight={400}>
          {get(consumer, 'name')}
        </Title>
        <Text>
          Consumer ID: <ConsumerId id={get(consumer, 'id')} />
        </Text>
        <ConsumerStatsWrapper>
          <ConsumerStats />
        </ConsumerStatsWrapper>
        <Divider />
        <Tabs
          defaultActiveKey={consumerTab}
          items={
            [
              {
                key: ConsumerViewTabEnum.Integrations,
                label: <span id='consumer-4'>Connections</span>,
                children: <ConsumerIntegrations />,
              },
              {
                key: ConsumerViewTabEnum.Logs,
                label: <span id='consumer-7'>Logs</span>,
                children: <ConsumerLogs />,
              },
              {
                key: ConsumerViewTabEnum.Api,
                label: <span id='consumer-8'>API Credentials</span>,
                children: <ConsumerCredentials />,
              },
              (isOwner || isAdmin) && {
                key: ConsumerViewTabEnum.Settings,
                label: <span id='consumer-9'>Settings</span>,
                children: <ConsumerSettings id={get(consumer, 'id')} />,
              },
            ].filter(Boolean) as any[]
          }
        />
      </Wrapper>
      <ConsumerGuide />
    </>
  );
};
